// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__11HcU","error":"Textarea_error__3-cpQ","readonly":"Textarea_readonly__2QmQc","disabled":"Textarea_disabled__qhpC3"};